<script>
   /*************************************************************
   * DistancePlot                                               *
   * --------------------                                       *
   * shows plot with score and orthogonal distances             *
   **************************************************************/

   import { Vector } from 'mdatools/arrays';
   import { max } from 'mdatools/stat';
   import { Axes, XAxis, YAxis, Box } from 'svelte-plots-basic/2d';

   import { pcamodel_get, pcares_get } from '../wasm/pcvpca';

   import PlotSeries from './PlotSeries.svelte';
   import AppLegend from './AppLegend.svelte';


   /*****************************************/
   /* Input parameters                      */
   /*****************************************/

   export let model;                           // global PLS model object
   export let pvoptions;                       // object with PV-options
   export let res;                             // JSON with results
   export let params;                          // JSON with main plot parameters

   // constant parameters
   const margins = [0.65, 0.75, 0.1, 0.5];
   const showGrid = true;
   const xLabel = 'Score distance, h/h0';
   const yLabel = 'Orthogonal distance, q/q0';

   function getDistanceValues(id, res, u0, params) {
      if (!params || !params.ncomp) return null;
      const h = new Vector(pcares_get(res, "hdist", params.ncomp));
      const q = new Vector(pcares_get(res, "qdist", params.ncomp));
      return { id: id, x: h.apply(v => v / u0.h[params.ncomp - 1]), y: q.apply(v => v / u0.q[params.ncomp - 1]) };
   }

   function getDistanceParams(model) {
      if (!model) return null;
      const h = pcamodel_get(model, "hmean");
      const q = pcamodel_get(model, "qmean");
      return { h, q };
   }

   $: title = params && params.ncomp ? 'Distance plot (A = ' + params.ncomp + ')' : '';

   $: u0 = getDistanceParams(model);
   $: ps = params && res ? Object.keys(res).map(id => getDistanceValues(id, res[id], u0, params)) : null;

   $: limX = ps ? [0, 1.2 * max(Object.keys(ps).map(id => max(ps[id].x.v)))] : [0, 1];
   $: limY = ps ? [0, 1.2 * max(Object.keys(ps).map(id => max(ps[id].y.v)))] : [0, 1];
</script>

{#if params && model && res && pvoptions }
<Axes {margins} {xLabel} {yLabel} {limX} {limY} {title} >

   {#each ps as series}
   <PlotSeries values={series} type="p" />
   {/each}

   <AppLegend />
   <XAxis {showGrid} slot="xaxis" />
   <YAxis {showGrid} slot="yaxis" />
   <Box slot="box" />
</Axes>
{/if}

